import styled from "styled-components";

export const MyReservationListWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MyReservationListItem = styled.div`
  background: #f0f0f0;
  border-radius: 8px;
  padding: 16px;

  > .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .content {
      display: flex;
      flex-direction: column;
      gap: 2px;

      > .title {
        font-weight: 600;
        font-size: 16px;
      }

      > .date {
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
`;

export const MyReservationListItemBottom = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .top {
    display: flex;
    gap: 8px;

    > img {
      width: 104px;
      height: auto;
      border-radius: 8px;
    }

    > .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      > .reservation-state {
        width: 88px;
        height: 24px;
        border-radius: 6px;
        background: #575757;
        color: #fff;

        font-weight: 600;
        font-size: 10px;
        text-align: center;
        line-height: 24px;
      }

      > .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 100%;
      }

      > .info-wrapper {
        display: flex;
        flex-direction: column;
        gap: 2px;
        > .info {
          font-weight: 600;
          font-size: 10px;

          > span {
            font-weight: 400;
            font-size: 10px;
            color: var(--Black-500, #202020);
          }
        }
      }
    }
  }

  > .button-wrapper {
    display: flex;

    > .button {
      font-weight: 600;
      font-size: 15px;
      text-align: center;
      flex: 0.4;
      line-height: 48px;
      height: 48px;
      cursor: pointer;

      &.purple {
        flex: 1;
        gap: 8px;
        border-radius: 8px;
        background: #6436e7;
        color: #fff;
      }
    }
  }
`;
